var map = {
	"./article.jpg": 27542,
	"./case_worker.jpg": 38927,
	"./course_completion_bronze.gif": 27124,
	"./course_completion_gold.gif": 5471,
	"./course_completion_silver.gif": 44561,
	"./cv_bronze.gif": 43869,
	"./cv_builder.gif": 4432,
	"./cv_gold.gif": 42740,
	"./cv_silver.gif": 2384,
	"./envelope-solid.png": 84295,
	"./games.gif": 58140,
	"./help_subtitles.png": 85931,
	"./high-speed-trains-ta05-wide.jpg": 22240,
	"./interview.gif": 32920,
	"./interview_game_bronze.gif": 39566,
	"./interview_game_gold.gif": 94598,
	"./interview_game_silver.gif": 33846,
	"./interview_help.gif": 17442,
	"./interview_help.png": 20795,
	"./interview_highscore.gif": 79427,
	"./intro.jpg": 73675,
	"./job_application.gif": 61862,
	"./job_application_bronze.gif": 28368,
	"./job_application_gold.gif": 78368,
	"./job_application_silver.gif": 23853,
	"./logo_grey.png": 16246,
	"./logo_white.png": 6364,
	"./manager_hunting.gif": 6929,
	"./manager_sad.mp4": 71341,
	"./memory.gif": 1292,
	"./memory_back.png": 48775,
	"./memory_game.gif": 50660,
	"./memory_help.gif": 81201,
	"./memory_help.png": 7441,
	"./memory_highscore.gif": 49172,
	"./minesweeper.gif": 14884,
	"./minesweeper_game.gif": 63411,
	"./minesweeper_help.gif": 47711,
	"./minesweeper_help.png": 15016,
	"./minesweeper_highscore.gif": 96414,
	"./mobile-bankid.svg": 198,
	"./nps.jpg": 91155,
	"./overview.jpg": 73482,
	"./phone-solid.png": 5980,
	"./podcast.jpg": 10866,
	"./pw_smoking.jpg": 13648,
	"./questions.jpg": 4801,
	"./quiz.jpg": 75764,
	"./response_1_angry.gif": 78059,
	"./response_1_chocked.gif": 63143,
	"./response_1_happy.gif": 51632,
	"./response_1_neutral.gif": 86065,
	"./response_1_sad.gif": 81219,
	"./response_1_shocked.gif": 53000,
	"./response_1_surprised.gif": 96684,
	"./response_2_angry.gif": 95447,
	"./response_2_chocked.gif": 93057,
	"./response_2_happy.gif": 98107,
	"./response_2_neutral.gif": 37821,
	"./response_2_sad.gif": 77450,
	"./response_2_shocked.gif": 92960,
	"./response_2_surprised.gif": 45446,
	"./summary.jpg": 52487,
	"./surveys.gif": 3609,
	"./tasks.gif": 92659,
	"./tools.gif": 80749,
	"./train.gif": 97565,
	"./u2work_help.png": 18783
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97173;